import { render, staticRenderFns } from "./diyarticle.vue?vue&type=template&id=d65c5028&scoped=true&"
import script from "./diyarticle.vue?vue&type=script&lang=js&"
export * from "./diyarticle.vue?vue&type=script&lang=js&"
import style0 from "./diyarticle.vue?vue&type=style&index=0&id=d65c5028&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d65c5028",
  null
  
)

export default component.exports